import { useTranslation } from "react-i18next";
import { TListingFilters } from "../components/listingTableHeader";

export const useListingFilters = () => {
  const { t: tFilters } = useTranslation("translation", {
    keyPrefix: "admins.filters",
  });

  const filters: TListingFilters[] = [
    {
      slug: "active",
      title: tFilters("active"),
    },
    {
      slug: "inactive",
      title: tFilters("inactive"),
    },
    {
      slug: "both",
      title: tFilters("both"),
    },
  ];

  return { filters };
};
